import type { ConfigType } from '@plone/registry';
import React from 'react';

import MinhasPendencias from 'volto-ministerio-publico-federal/components/manage/MinhasPendencias/MinhasPendencias';
import AuditarAcervo from 'volto-ministerio-publico-federal/components/manage/AuditarAcervo/AuditarAcervo';

import { ROUTES } from './routes.constants';
import VersaoProfile from 'volto-ministerio-publico-federal/components/manage/Controlpanels/VersaoProfile/VersaoProfile';
import PermissoesControlpanel from 'volto-ministerio-publico-federal/components/manage/Controlpanels/Permissoes/PermissoesControlpanel';
import PaginaNotificacoes from 'volto-ministerio-publico-federal/components/manage/Notificacoes/PaginaNotificacoes';

export const updateRoutesConfig = (config: ConfigType) => {
  config.addonRoutes = [
    ...(config.addonRoutes ?? []),
    {
      path: ROUTES.MINHAS_PENDENCIAS,
      component: MinhasPendencias,
      exact: true,
    },
    {
      path: ROUTES.PENDENCIAS_LEGADAS,
      component: () =>
        React.createElement(MinhasPendencias, { escopo: 'legado' }),
      exact: true,
    },
    {
      path: ROUTES.AUDITAR_ACERVO,
      component: AuditarAcervo,
      exact: true,
    },
    // Central de notificações do fluxo editorial (sino da Toolbar).
    {
      path: ROUTES.NOTIFICACOES,
      component: PaginaNotificacoes,
      exact: true,
    },
    // Pelo mesmo motivo, a página de contato da unidade também deixou de ser
    // rota fixa: /o-mpf/unidades/<unidade>/contato-1 é um Folder real
    // (layout: contato_view -> UnidadeContato, ver upgrade_1039 no backend).
    // Enquanto era rota, ela buscava o conteúdo da unidade pai só para ter o
    // que exibir, e isso sobrescrevia o breadcrumb da própria página.
    // Painel custom que mostra a versão de profile aplicada no banco vs. a do
    // código. Precede o `/controlpanel/:id` do core (addonRoutes têm
    // prioridade), então não conflita com o painel de add-ons nativo.
    {
      path: ROUTES.CONTROLPANEL_VERSAO,
      component: VersaoProfile,
      exact: true,
    },
    // Perfis de acesso: o Manager escolhe o que cada grupo/usuário vê e
    // gerencia (painéis, toolbar, layouts, tipos, blocos). Ver backend
    // `perfis/` e o serviço `@mpf-perfis`.
    {
      path: ROUTES.CONTROLPANEL_PERMISSOES,
      component: PermissoesControlpanel,
      exact: true,
    },
  ];
  return config;
};

export default updateRoutesConfig;
